import { createRouter, createWebHistory } from 'vue-router'
import { authStore } from '@stores/auth'

import del from './del'
//import security from '@/shared/security'

const router = createRouter({
    history: createWebHistory(),
    routes: [...del],
})

router.beforeEach(async (to, from, next) => {
    const auth = authStore()     
    if (to.matched.some(record => record.meta.requiresAuth) && !auth.isAuthenticated) {
        //authentication is required. Trigger the sign in process, including the return URI
        //await security.connect(to.name as string)        
        
        if(auth.isAuthenticated)
            next()        
        else
            next({ name: 'connecting' })//juste pour eviter un warning.. mais va rediriger avant normalement
        
    }     
    // else if (to.path == '/signin-oidc'){        
    //     //await security.connect_callback(to.query.code as string, to.query.state as string)        
    //     next({ name: auth.nextRoute })
    // }
    else {
        //No auth required. We can navigate
        next()        
    }
    return false
})

export default router
